import { useCallback, useMemo } from 'react';
import { notNil } from '@shared/util/notNil';
import * as Actions from '../store/actions';

export function useToggleReaction(message: MBAPI.ChatMessage, channelSlug: string) {
  return useCallback(
    (reaction: MBAPI.ReactionType, add: boolean) =>
      Actions.toggleReaction(message, channelSlug, reaction, add),
    [message, channelSlug],
  );
}

export function useSelectedReactions(message: MBAPI.ChatMessage): MBAPI.ReactionType[] {
  return useMemo(() => {
    const reactions: MBAPI.Reaction[] = message.meta.reactions.filter(notNil) ?? [];
    return reactions.filter(reaction => reaction.user.isMe).map(reaction => reaction.type);
  }, [message.meta.reactions]);
}
